import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteMultiplierType($companyId: ID!, $id: ID!) {
    deleteMultiplierType(companyId: $companyId, id: $id) {
      multiplierType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
